//tslint:disable:export-name
export { ProductUgcService } from './service-setup/ProductUgcService';
import { diContainer, serviceNames } from './service-setup/diContainer';

diContainer.get(serviceNames.productUgcService).register();
